import { CronFrequencyEnum, CustomFrequencyEnum } from '@/types/schema';

export const RECURRING_SESSION_ALLOWED_FREQUENCIES = [
  CronFrequencyEnum.Daily,
  CronFrequencyEnum.Weekly,
  CronFrequencyEnum.Monthly,
  CronFrequencyEnum.Custom,
];

export const RECURRING_SESSION_ALLOWED_CUSTOM_FREQUENCIES = [
  CustomFrequencyEnum.Day,
  CustomFrequencyEnum.Week,
  CustomFrequencyEnum.Month,
];
